import { useI18n } from "../../lib/i18n";
import { Link } from "../../lib/router";

/** Privacy policy, terms and company details: on the front page, the sign-up form and the legal pages. */
export function LegalLinks() {
  const { t } = useI18n();
  return (
    <nav className="legal-links small">
      <Link to="/privacy">{t("legal.privacy")}</Link>
      <Link to="/terms">{t("legal.terms")}</Link>
      <Link to="/refund">{t("legal.refund")}</Link>
      <Link to="/imprint">{t("legal.imprint")}</Link>
    </nav>
  );
}
